import styled from 'styled-components'

export const FreshContainer = styled.div`
  background-image: linear-gradient(to right top, #aaff5f, #99f14d, #88e33b, #77d625, #65c800);
  width: 23%;
  height: 475.42px;
  margin: 15px 0 0 30px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;  
  @media screen and (max-width: 1399px){
    height: 426.31px;
  }
  @media screen and (max-width: 1249px){
    height: 373.55px;
  }
`


export const FreshMobileContainer = styled.div`
  background-image: linear-gradient(to right top, #aaff5f, #99f14d, #88e33b, #77d625, #65c800);
  width: 100%;
  height: 200px;
  margin: 0 0 15px 0 ;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;  
 
`

export const FreshMobileTop = styled.div`
  width: 90%;
  display: flex;
  justify-content: space-between;
  
`
export const FreshTabletTop = styled.div`
  width: 95%;
  display: flex;
  justify-content: space-between;
  
`


export const FreshMobileHeader = styled.div`
  
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  svg{
    height: 50px;
    @media screen and (max-width: 1399px){
      height: 40px;
    }
    @media screen and (max-width: 1249px){
      height: 40px;
    }
  }
`
export const FreshHeader = styled.div`
  
  width: 80%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  svg{
    height: 50px;
    @media screen and (max-width: 1399px){
      height: 40px;
    }
    @media screen and (max-width: 1249px){
      height: 40px;
    }
  }
`

export const FreshTitleBox = styled.div`
  display: flex;
  flex-direction: column;
`
export const FreshTitle = styled.h2`
  font-family: ${props => props.theme.font.family.medium};
  font-size: 25px;
  font-weight: bolder;
  
  @media screen and (max-width: 1399px){
    font-size: 20px;
  }
  @media screen and (min-width:1100px) and (max-width: 1249px){
    font-size: 16px;
  }
`

export const FreshSecondaryTitle = styled.h2`
  color: white;
  font-family: ${props => props.theme.font.family.medium};
  font-weight: lighter;
  font-size: 15px;
  @media screen and  (max-width: 1399px){
    font-size: 13px;
  }
  @media screen and (min-width:1100px) and (max-width: 1249px){
    font-size: 11px;
  }
`

export const FreshProducts = styled.div`
  display: flex;
  width: 80%;
  flex-direction: column;
  height: 60%;
  justify-content: space-around;
  align-items: center;
`

export const FreshMobileProducts = styled.div`
  display: flex;
  height: 60%;
  justify-content: space-around;
  align-items: center;
`

export const FreshTabletProducts = styled.div`
  display: flex;
  width: 100%;
  height: 60%;
  justify-content: space-around;
  align-items: center;
`

export const FreshItem = styled.a`
  height: 45%;
  width: 100%;
  background-color: white;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  img{
    margin-bottom: 10px;
    padding: 10px 5px 10px 10px;
    height: 100%;
  }
`

export const FreshMobileItem = styled.a`
  height: 80%;
  width: 45%;
  max-width: 300px;
  background-color: white;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  img{
    object-fit: contain;
    margin-bottom: 10px;
    padding: 10px 5px 10px 10px;
    max-width: 50%; 
    height: auto;
  }
  p{
    font-size: 16px;
  }
  .price-icon{
    font-size: 14px;
  }
`
export const FreshTabletItem = styled.a`
  height: 80%;
  width: 45%;
  max-width: 230px;
  background-color: white;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  img{
    object-fit: contain;
    margin-bottom: 10px;
    padding: 10px 5px 10px 10px;
    max-width: 50%; 
    height: auto;
  }
`

export const FreshExtend = styled.a`
  height: 50px;
  display: flex;
  align-items: center;
  h2{
    font-family: ${props => props.theme.font.family.medium};
    padding-right: 10px;
    
    
  }
`